import { Injectable } from "@angular/core";
import { StateManagementService } from "providers/state-management/state-management.service";
import { ConfigurationService } from "../providers/configuration/configuration.service";

@Injectable()
export default class HeaderData {
  assessmentType: string;
  applications: Array<{
    id: string;
    appResourceId: number;
    icon: string;
    url: string;
  }>;
  notifications: Array<object>;
  profileInfo: { name: string; portrait: string };
  reminders: Array<object>;

  constructor(
    private configurationService: ConfigurationService,
    public stateData: StateManagementService
  ) {
    this.assessmentType = "patientAssessment";
    this.applications = [
      {
        id: "company",
        appResourceId: 111,
        icon: "md-briefcase",
        url: configurationService.getConfig().clinicalUrl + "/#/company",
      },
      {
        id: "oldPatientsApp",
        appResourceId: 333,
        icon: "md-contacts",
        url: configurationService.getConfig().betaAppUrl + "?module=patients",
      },
      {
        id: "patientsApp",
        appResourceId: 333,
        icon: "md-contacts",
        url: configurationService.getConfig().clinicalUrl + "/#/patients",
      },
      {
        id: "billing",
        appResourceId: 222,
        icon: "md-paper",
        url: configurationService.getConfig().betaAppUrl + "?module=billing",
      },
      {
        id: "hisExport",
        appResourceId: 444,
        icon: "md-contacts",
        url: configurationService.getConfig().clinicalUrl + "/#/his",
      },
      {
        id: "compliance",
        appResourceId: 444,
        icon: "md-checkmark-circle-outline",
        url: configurationService.getConfig().betaAppUrl + "?module=compliance",
      },
      {
        id: "resourcemanagement",
        appResourceId: 162,
        icon: "md-medkit",
        url:
          configurationService.getConfig().clinicalUrl + "/#/company-resources",
      },
      {
        id: "facilities",
        appResourceId: 163,
        icon: "md-medkit",
        url: configurationService.getConfig().betaAppUrl + "?module=providers",
      },
      {
        id: "reports",
        appResourceId: 555,
        icon: "md-clipboard",
        url: configurationService.getConfig().betaAppUrl + "?module=reports",
      },
      {
        id: "analytics",
        appResourceId: 900,
        icon: "md-clipboard",
        url:
          configurationService.getConfig().clinicalUrl +
          "/#/billing/month-end-close",
      },
      {
        id: "community_bereavement",
        appResourceId: 500,
        icon: "md-clipboard",
        url:
          configurationService.getConfig().clinicalUrl +
          "/#/community-bereavement",
      }, //
      {
        id: "palliative_billing",
        appResourceId: 2000,
        icon: "md-clipboard",
        url:
          configurationService.getConfig().clinicalUrl +
          "/#/billing/claim-management",
      },
      {
        id: "listOrdersPages",
        appResourceId: 333,
        icon: "md-clipboard",
        url:
          configurationService.getConfig().clinicalUrl +
          "/#/patient/listOrders",
      },
      {
        id: "ePrescribePage",
        appResourceId: 666,
        icon: "md-clipboard",
        url:
          configurationService.getConfig().clinicalUrl +
          "/#/provider/eprescribe",
      },
    ];
    this.notifications = [];
    this.profileInfo = {
      name: "Mary Carson-Johnson, MD",
      portrait: "../../../assets/mantis/silhouette.jpg",
    };
    this.reminders = [];
  }
}



// WEBPACK FOOTER //
// ./src/mocks/mock-header-data.ts